import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';

const QUESTIONS = [
    { id: 1, text: "Le client est-il prêt à s'investir ?", weight: 25 },
    { id: 2, text: "A-t-il un budget marketing cohérent ?", weight: 25 },
    { id: 3, text: "Vise-t-il la qualité avant le prix ?", weight: 25 },
    { id: 4, text: "Est-il sympa et éthique ?", weight: 25 },
];

export default function CommercialGreenLightPage() {
    const navigate = useNavigate();
    const [answers, setAnswers] = useState({});
    const [analyzing, setAnalyzing] = useState(false);
    const [result, setResult] = useState(null); // 'approved' or 'rejected'

    const handleAnswer = (qid, val) => setAnswers(prev => ({ ...prev, [qid]: val }));

    const scan = () => {
        setAnalyzing(true);
        setTimeout(() => {
            setAnalyzing(false);
            const score = QUESTIONS.reduce((acc, q) => acc + (answers[q.id] ? q.weight : 0), 0);
            setResult(score >= 75 ? 'approved' : 'rejected');
        }, 3000); // Suspense
    };

    const allAnswered = QUESTIONS.every(q => answers[q.id] !== undefined);

    if (result === 'approved') {
        return (
            <div className="animate-fade-in" style={{ height: '100vh', width: '100vw', background: '#22c55e', color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                <Confetti recycle={true} numberOfPieces={200} colors={['#ffffff', '#86efac']} />

                <div style={{ fontSize: '8rem', marginBottom: 20, animation: 'bounceIn 1s' }}>✅</div>
                <h1 style={{ fontSize: '4rem', fontWeight: 900, textTransform: 'uppercase', margin: 0 }}>Projet Validé !</h1>
                <p style={{ fontSize: '1.5rem', opacity: 0.9, maxWidth: 600, marginTop: 20 }}>Votre profil correspond à nos critères d'excellence. <br />Bienvenue dans l'Accélérateur.</p>

                <button onClick={() => navigate('/commercial/sign')} style={{ marginTop: 50, padding: '20px 50px', background: 'white', color: '#166534', border: 'none', borderRadius: 50, fontSize: '1.5rem', fontWeight: 800, cursor: 'pointer', boxShadow: '0 20px 50px rgba(0,0,0,0.2)' }}>
                    SIGNER LE PARTENARIAT ✒️
                </button>

                <button onClick={() => setResult(null)} style={{ marginTop: 20, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.6)', cursor: 'pointer' }}>Retour</button>
                <style>{`@keyframes bounceIn { 0% { transform: scale(0.3); opacity: 0; } 50% { transform: scale(1.05); } 70% { transform: scale(0.9); } 100% { transform: scale(1); opacity: 1; } }`}</style>
            </div>
        );
    }

    if (result === 'rejected') {
        return (
            <div className="animate-fade-in" style={{ height: '100vh', width: '100vw', background: '#ef4444', color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                <div style={{ fontSize: '8rem', marginBottom: 20 }}>⚠️</div>
                <h1 style={{ fontSize: '4rem', fontWeight: 900, textTransform: 'uppercase', margin: 0 }}>Critères Insuffisants</h1>
                <p style={{ fontSize: '1.5rem', opacity: 0.9, maxWidth: 600, marginTop: 20 }}>Désolé, nous ne pouvons pas accepter ce dossier pour le moment.<br />Le score de compatibilité est trop faible.</p>

                <button onClick={() => { setResult(null); setAnswers({}); }} style={{ marginTop: 50, padding: '15px 40px', background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', borderRadius: 50, fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer' }}>Réessayer</button>
            </div>
        );
    }

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

            {analyzing ? (
                <div style={{ textAlign: 'center' }}>
                    <div className="radar-scan" style={{ width: 300, height: 300, border: '2px solid #3b82f6', borderRadius: '50%', position: 'relative', overflow: 'hidden', background: 'radial-gradient(circle, rgba(59,130,246,0.1) 0%, rgba(0,0,0,0) 70%)' }}>
                        <div className="radar-line" style={{ width: '50%', height: '50%', borderRight: '2px solid #60a5fa', position: 'absolute', top: 0, left: 0, transformOrigin: 'bottom right', background: 'linear-gradient(45deg, rgba(59,130,246,0) 50%, rgba(59,130,246,0.5) 100%)', animation: 'spin 2s linear infinite' }} />
                        <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center', fontSize: '2rem', fontWeight: 700 }}>ANALYSE...</div>
                    </div>
                    <p style={{ marginTop: 30, opacity: 0.7, fontSize: '1.2rem' }}>Calcul de la compatibilité projet...</p>
                    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                </div>
            ) : (
                <div style={{ width: '100%', maxWidth: 700 }}>
                    <div style={{ textAlign: 'center', marginBottom: 40 }}>
                        <div style={{ fontSize: '3rem', marginBottom: 10 }}>🚦</div>
                        <h1 style={{ fontSize: '2.5rem', fontWeight: 800 }}>Éligibilité Projet</h1>
                        <p style={{ opacity: 0.6 }}>Vérifions si nous sommes faits pour travailler ensemble.</p>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                        {QUESTIONS.map((q, idx) => (
                            <div key={idx} style={{ background: 'rgba(255,255,255,0.05)', padding: 25, borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid rgba(255,255,255,0.1)' }}>
                                <div style={{ fontSize: '1.2rem', fontWeight: 500 }}>{q.text}</div>
                                <div style={{ display: 'flex', gap: 10 }}>
                                    <button
                                        onClick={() => handleAnswer(q.id, false)}
                                        style={{ width: 50, height: 50, borderRadius: '50%', border: 'none', background: answers[q.id] === false ? '#ef4444' : 'rgba(255,255,255,0.1)', color: 'white', fontSize: '1.2rem', cursor: 'pointer', transition: 'all 0.2s' }}
                                    >❌</button>
                                    <button
                                        onClick={() => handleAnswer(q.id, true)}
                                        style={{ width: 50, height: 50, borderRadius: '50%', border: 'none', background: answers[q.id] === true ? '#22c55e' : 'rgba(255,255,255,0.1)', color: 'white', fontSize: '1.2rem', cursor: 'pointer', transition: 'all 0.2s' }}
                                    >✅</button>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button
                        onClick={scan} disabled={!allAnswered}
                        style={{
                            width: '100%', marginTop: 40, padding: 25, borderRadius: 50, border: 'none',
                            background: allAnswered ? 'white' : 'rgba(255,255,255,0.1)', color: allAnswered ? 'black' : 'rgba(255,255,255,0.3)',
                            fontSize: '1.3rem', fontWeight: 800, cursor: allAnswered ? 'pointer' : 'not-allowed',
                            boxShadow: allAnswered ? '0 10px 40px rgba(255,255,255,0.2)' : 'none', transform: allAnswered ? 'scale(1)' : 'scale(0.98)', transition: 'all 0.3s'
                        }}
                    >
                        {allAnswered ? 'LANCER LE SCAN' : 'Répondez aux critères...'}
                    </button>
                </div>
            )}
            <button onClick={() => navigate('/commercial/launchpad')} style={{ position: 'fixed', bottom: 30, left: '50%', transform: 'translateX(-50%)', background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Annuler</button>
        </div>
    );
}
